module.exports = __webpack_public_path__ + "img/Cuban_Bowl_Tofu.8202af83.jpg";